import { render, staticRenderFns } from "./taskDetails.vue?vue&type=template&id=b82db3bc&scoped=true&"
import script from "./taskDetails.vue?vue&type=script&lang=js&"
export * from "./taskDetails.vue?vue&type=script&lang=js&"
import style0 from "./taskDetails.vue?vue&type=style&index=0&id=b82db3bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82db3bc",
  null
  
)

export default component.exports